var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 21.002V21l1.875-2.023a.48.48 0 00-.415-.802l-2.35.31a4 4 0 00-6.823 4.007c-2.996-.07-6.204-.663-7.826-3.877-.2-.397-.776-.42-.904.006-1.174 3.92.892 9.014 5.443 10.379-1.136 1.11-4.054 1.411-6.442 1.193-.465-.043-.757.487-.397.784C18.163 32.637 20.94 33 23.5 33 30 33 34.499 27.501 34 21.002z"
  })));
}
export default SvgTwitterIcon;